var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12 profile-card-2" }, [
    _c(
      "div",
      {
        staticClass: "card p-05 shadow-none",
        staticStyle: { width: "100%", border: "none" },
      },
      [
        _c(
          "div",
          { staticClass: "card-content p-0" },
          [
            _vm._l(_vm.likedByUsers, function (member, index) {
              return index < 10 && member.deleted_at === null
                ? _c("div", { key: member.id }, [
                    _c(
                      "div",
                      {
                        staticClass: "card shadow-none p-0",
                        staticStyle: { border: "none" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("div", { staticClass: "pr-1" }, [
                              _c("img", {
                                staticClass: "round",
                                attrs: {
                                  src:
                                    member.user_image !== null
                                      ? member.user_image
                                      : "/images/avatar.png",
                                  alt: "avatar",
                                  height: "20",
                                  width: "20",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-bold-600",
                                staticStyle: { color: "inherit" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(member.full_name) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm.likedByUsers.length > 10
              ? _c("span", [
                  _vm._v(
                    "And " +
                      _vm._s(_vm.likedByUsers.length - 10) +
                      " " +
                      _vm._s(_vm.__("globals.more")) +
                      "..."
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }